<script setup>
import { onMounted, ref, computed, onUnmounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { useUsuarioStore } from '@/store/usuarioStore';

import SpinnerLoader from '@/components/Spinner/SpinnerLoader.vue';
import { isGlobalLoadingVisible } from '@/utils/globalLoading';

import Navbar from '@/layouts/Navbars/Navbar.vue';
import AppFooter from '@/layouts/Footer.vue';

import {
  dejarCanalDeSession,
  suscribirAlCanalSession,
} from '@/realtime/canalSession';
import {
  suscribirACanalCredito,
  dejarCanalCredito,
} from '@/realtime/canalCredito';

const store = useStore();
const usuarioStore = useUsuarioStore();
const route = useRoute();
const router = useRouter();

const appReady = ref(false);

onMounted(async () => {
  await router.isReady();

  const hasValidSession = await usuarioStore.getSession();


if (hasValidSession) {
  suscribirAlCanalSession();
  suscribirACanalCredito((summary) => {
    console.log("[App] applying CreditUpdated summary", summary);
    usuarioStore.actualizarResumenGarantias(summary);
  });
  await usuarioStore.refrescarResumenGarantiasUsuario();
  }
  appReady.value = true;
});

onUnmounted(() => {
  dejarCanalDeSession();
  dejarCanalCredito();
});

const layoutDisabledRoutes = new Set(['/logout', '/confirmar-login-externo']);

const hideLayout = computed(() => {
  const cleanPath = route.path.replace(/\/+$/, '');
  return layoutDisabledRoutes.has(cleanPath);
});

const layout = computed(() => store.state.layout);
const showFooter = computed(() => store.state.showFooter);
</script>

<template>
  <!-- Evita renderizar hasta que esté listo el router -->
  <template v-if="appReady">
    <div v-if="isGlobalLoadingVisible" class="spinner-overlay" aria-live="polite" aria-busy="true">
      <SpinnerLoader />
    </div>

    <!-- Fondo tipo landing -->
    <div
      v-show="layout === 'landing'"
      class="landing-bg h-100 bg-gradient-primary position-fixed w-100"
    ></div>

    <div v-if="!hideLayout">
      <main class="main-content position-relative max-height-vh-100 h-100 border-radius-lg">
        <navbar />
        <router-view />
        <app-footer v-show="showFooter" />
      </main>
    </div>
  </template>
</template>

<style>
.spinner-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10000;
  background-color: rgba(255, 255, 255, 0.95);
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
